<template>
	<div class="card" :class="{active: active}">
		<span>Sinonimo</span>
		<div class="synonyms" v-if="synonyms">
			<span class="syn">{{synonyms}}</span>
		</div>
	</div>
</template>

<script>

export default {
	props: ['synonyms'],
	data() {
		return {
			active: false,
		}
	},
	mounted() {
		setTimeout(() => {
			this.playAudio('synonym');
			this.active = true
		},10)
	}
}
</script>
<style scoped lang="scss">
	.card {
		background: $mondadori-blue;
		display: inline-block;
		padding: px(5) px(30);
		color: $mondadori-yellow;
		border-radius: px(20);
		transition: all 0.3s;
		opacity: 0;
		max-width: px(400);
		float: right;

		* {
			line-height: px(20);
		}

		&.active {
			animation-name: baloon;
			animation-duration: 0.25s;
			animation-fill-mode: forwards;	
		}

		@keyframes baloon {
			0% {transform: scale(0); opacity: 0;}
			100% {transform: scale(1.2); opacity: 1;}
			100% {transform: scale(1); opacity: 1;}
		}

		& > span {
			text-transform: uppercase;
			font-weight: normal;
			font-size: px(14);
			display: block;
			color: $mondadori-yellow;
		}
		.syn {
			color: $mondadori-yellow;
			font-size: px(20);
		}
	}
</style>